import { createContext } from 'react';

export const AUTHENTICATION = 'AUTH/authentication';
export const LOGIN = 'AUTH/login';
export const LOGIN_SSO = 'AUTH/login_sso';
export const FORGOT_PASSWORD_SEND = 'AUTH/forgot_password_send_instruction';
export const FORGOT_PASSWORD_CONFIRM = 'AUTH/forgot_password_confirm';
export const FORGOT_PASSWORD_SET = 'AUTH/forgot_password_set_new';

export const REGISTER = 'AUTH/register';
export const PROFILE = 'AUTH/profile';
export const CHANGE_PASSWORD = 'AUTH/change_password';
export const CREATE_ACCOUNT = 'AUTH/create_account';
export const CURRENT_ACCOUNT = 'AUTH/current_account';
export const TOGGLE_MODE = 'ACCOUNT/toggle_mode';

export const MyAccountContext = createContext();
export const ProfileContext = createContext();
